export default "__VITE_ASSET__Cr297HPP__"